import { isAxiosError } from 'axios'

// A save the server rejects says why, e.g. which portal needs payments enabled for Full Catalog.
export function rejection(error: unknown): string | undefined {
  if (!isAxiosError(error) || error.response?.status !== 400) return undefined
  const body = error.response.data as { message?: unknown } | undefined
  if (typeof body?.message === 'string' && body.message) return body.message
  // An Envoy without convert_grpc_status sends it percent-encoded in grpc-message, with an empty body.
  const message = error.response.headers['grpc-message']
  if (typeof message !== 'string' || !message) return undefined
  try {
    return decodeURIComponent(message)
  } catch {
    return message
  }
}
